import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import "./privacy-policy.css";

export default function PrivacyPolicy() {
  return (
    <>
      <Header />

      <main className="privacy-page">
        <div className="privacy-hero">
          <h1>Privacy Policy</h1>
          <p>
            At Aethearia, your privacy matters to us. This Privacy Policy
            explains how we collect, use, store, and protect your personal
            information when you visit our website, place an order, or interact with us.
          </p>
        </div>

        <div className="privacy-grid">
          <section className="privacy-card">
           

            <h3>1. Information We Collect</h3>

            <p>
              When you interact with Aethearia, we may collect personal
              information such as your name, email address, phone number,
              billing and shipping address, IP address, and order details. This
              information helps us process orders, provide customer support, and
              improve your experience with our brand.
            </p>

            <h3>2. Orders & Payments</h3>

            <p>
              To fulfil your purchases, we collect billing, shipping, and
              transaction-related details. Payments on our website are securely
              processed through trusted third-party payment providers. Aethearia
              does not store your complete credit or debit card information.
            </p>

            <h3>3. Customer Support</h3>

            <p>
              If you contact us for assistance, we may collect information
              related to your query, order history, and communication records to
              help resolve your concerns and improve our customer experience.
            </p>
          </section>

          <section className="privacy-card">

            <h3>4. Website Analytics</h3>

            <p>
              We may automatically collect certain technical and browsing
              information such as your device type, browser, pages visited, time
              spent on the website, and referral source. This helps us
              understand website usage and improve site performance and user
              experience.
            </p>

            <h3>5. Cookies</h3>

            <p>
              Our website may use cookies and similar technologies to improve
              website functionality, remember your preferences, analyse traffic,
              and personalise your browsing experience. You can manage or
              disable cookies through your browser settings at any time.
            </p>
          </section>

          <section className="privacy-card">
           

            <h3>6. How We Use Your Information</h3>

            <p>We use your information to:</p>

            <ul>
              <li>Process and deliver your orders</li>
              <li>Communicate order updates and respond to your queries</li>
              <li>Provide customer support</li>
              <li>Improve our website, products, and services</li>
              <li>Prevent fraud or misuse of our website</li>
              <li>
                Send promotional updates where you have consented or where
                permitted by law
              </li>
            </ul>

            <h3>7. Marketing Communications</h3>

            <p>
              With your consent, we may send you updates about new launches,
              offers, and brand news. You can opt out of marketing
              communications at any time by clicking the unsubscribe link in our
              emails or by contacting us directly.
            </p>
          </section>

          <section className="privacy-card">
            {/* <span className="section-tag">Sharing</span>

            <h2>Sharing & Security</h2> */}

            <h3>8. Sharing of Information</h3>

            <p>
              We only share your information with trusted third-party service
              providers necessary to operate our business, such as payment
              gateways, shipping partners, website hosting providers, analytics
              tools, and customer support platforms. We do not sell your
              personal information.
            </p>

            <h3>9. Data Security</h3>

            <p>
              We take reasonable administrative, technical, and organisational
              measures to protect your personal information from unauthorised
              access, misuse, loss, or disclosure. While no online platform can
              guarantee absolute security, we continuously work to safeguard the
              information shared with us.
            </p>
          </section>

          <section className="privacy-card">
            {/* <span className="section-tag">Rights</span>

            <h2>Data Retention & Your Rights</h2> */}

            <h3>10. Data Retention</h3>

            <p>
              We retain personal information only for as long as necessary to
              provide our services, fulfil orders, comply with legal obligations,
              resolve disputes, and enforce our policies.
            </p>

            <h3>11. Your Rights</h3>

            <p>
              Subject to applicable law, you may request access to, correction
              of, or deletion of your personal information. You may also withdraw
              your consent to receive marketing communications at any time.
            </p>

            <p className="note-highlight">
              To make such a request, please contact us at{" "}
              <span className="email-lowercase">reachus@aethearia.com</span>.
            </p>
          </section>

          <section className="privacy-card">
            {/* <span className="section-tag">Third Party</span>

            <h2>Third-Party Platforms</h2> */}

            <h3>12. Third-Party Platforms</h3>

            <p>
              Our website may use or link to third-party platforms and services,
              including payment gateways, analytics providers, and social media
              platforms. These third parties operate under their own privacy
              practices, and we encourage you to review their policies before
              sharing personal information with them.
            </p>

            <h3>13. Policy Updates</h3>

            <p>
              We may update this Privacy Policy from time to time to reflect
              changes in our business practices, technologies, or legal
              requirements. Any changes will be posted on this page and will
              become effective upon posting.
            </p>
          </section>

          <section className="privacy-card full">
            {/* <span className="section-tag">Contact</span> */}

            <h2>14. Contact Us</h2>

            <p>
              If you have any questions about this Privacy Policy or would like
              to access, update, or request deletion of your personal
              information, please contact us at:
            </p>

            <div className="contact-box">
              <p>
                <b>Company:</b> Aether Falcon Endevours
              </p>

              <p>
                <b>Brand:</b> Aethearia
              </p>

              <p>
                <b>Address:</b> H.I.G/B-20, Housing Board Colony, Nagpur,
                Maharashtra – 440022, India
              </p>

             <p>
              <b>Email:</b>{" "}
              <a
                href="mailto:reachus@aethearia.com"
                className="email-lowercase"
              >
                reachus@aethearia.com
              </a>
            </p>

              <p>
                <b>Support Hours:</b> Monday to Friday, 10 AM – 6 PM IST
              </p>
            </div>
          </section>
        </div>
      </main>

      <Footer />
    </>
  );
}